import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { CONTACT_API } from '../../api/contact-api';
import { ContactBulkInterface } from '../../types/contact-menu-interface';
export const useContactsBulkRestore = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = data => fetcher(`${CONTACT_API}/bulk-actions/bulk-restore`, data);
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isFetching || $[4] !== t1) {
    t2 = {
      contactsBulkRestore: t1,
      isFetching
    };
    $[3] = isFetching;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};